const send2 = {
	init() {
		const redirectHref = document.querySelector('a#redirectUrl');
		if (redirectHref) {
			const time = redirectHref.getAttribute('time');
			const delayInMilliseconds = time * 1000;

			window.setTimeout(() => {
				const opener = window.open(redirectHref.getAttribute('href'));

				window.setTimeout(() => {
					if (!opener || opener.closed || typeof opener.closed === 'undefined') {
						redirectHref.classList.add('btn', 'btn-success');
						const popupBlocker = document.querySelector('span.popup-blocker');
						if (popupBlocker) {
							popupBlocker.classList.remove('d-none');
							popupBlocker.style.display = 'block';
						}
					}
				}, 1000);

				window.setTimeout(() => {
					redirectHref.parentElement.style.display = 'none';
					redirectHref.removeAttribute('href');
					redirectHref.setAttribute('disabled', true);

					const linkVerlopen = document.querySelector('span.link-verlopen');
					if (linkVerlopen) {
						linkVerlopen.classList.remove('d-none');
						linkVerlopen.style.display = 'block';
					}
				}, 600000);
			}, delayInMilliseconds);
		}
	},
};

export default send2;
